<template>
    <v-container
        fluid
        class="sidebar-content general-sidebar"
    >
        <WidgetsList
            v-if="widgetList"
            :widgetList="widgetList"
            @go-to-widget="goToWidget"
            @go-to-hotspot="goToHotspot"
        />
    </v-container>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import WidgetsList from '@/layout/sidebar/components/WidgetsList';

    export default {
        name: 'GeneralSidebar',
        components: {
            WidgetsList
        },
        props: [
            'widgetList',
            'handler'
        ],
        mounted() {
            this.handler();
        },
        methods: {
            goToWidget(widget) {
                let hasActiveHotspot = false;
                if (widget.active)
                    if (widget.hotspots) {
                        let activeHotspot = widget.hotspots.filter(hotspot => hotspot.active);
                        if (activeHotspot.length)
                            hasActiveHotspot = true;
                    }

                if ((!hasActiveHotspot && !widget.active) || (hasActiveHotspot && widget.active))
                    EventBus.$emit('generalView_SetActive', widget);
            },
            goToHotspot(widget, hotspot) {
                EventBus.$emit('hotspot_setActive', widget, hotspot);
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/layout/sidebar/general/GeneralSidebar.vue